import { adminHttpClient } from "../../../commons/adminHttpClinet";
import { WithdrawStatisticsModel } from "../../../models/dashboard/withdraw/withdraw";


const getWithdrawalStatistics = (): Promise<WithdrawStatisticsModel> => {
    return adminHttpClient.get(`/api/Admin/AdminMoveMoney/get-withdraw-statistics`)
}
export default getWithdrawalStatistics